import React , { useState , useEffect } from 'react';
import {
    Card,
    CardBody,
    Input,
    CardHeader,
  } from "reactstrap";
  import { useSelector , useDispatch } from 'react-redux';
  import { update_Bot_Combine } from '../../../slices/thunks';
import Loader from '../../../Components/Common/Loader';
  
const Text = () => {

  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const  create_new_bot_details =  useSelector((state) => state.Create_Bot)
  const dispatch = useDispatch()


  const  [text, settext] = useState('')



  const onClick_update_text = () => {

    let data = new FormData();
   
    data.append('assistant_id',BotDetails.Assets_ID)
    data.append('Bot_ID',BotDetails.Bot_ID)
    data.append('API_TYPE','Text')
    data.append('text',text)

    dispatch(update_Bot_Combine(data))

   

  }


  useEffect(() => {
    settext(BotDetails.text)
  }, [BotDetails])
  
 


  



  return (
    <>
      <Card>
              <CardHeader>
                <div className="hed_detail">
                  <span>
                    <b>Text</b>
                  </span>
                  <span>
                 {!(BotDetails.loading || create_new_bot_details.loading) &&
                    <button
                    onClick={()=>{
                      onClick_update_text()
                    }}
                      type="button"
                      class="btn btn-secondary waves-effect waves-light"
                    >
                      Save
                    </button>}
                  </span>
                </div>
              </CardHeader>
              {(BotDetails.loading || create_new_bot_details.loading)? <Loader/>:<CardBody>
                <textarea
                  value={text}
                  className="form-control"
                  id="exampleFormControlTextarea5"
                  rows="8"
                  onChange={(e)=>{
                    settext(e.target.value)
                  }}
                ></textarea>
              </CardBody>}
            </Card>
    </>
  )
}

export default Text
